import React, { useEffect, useState } from 'react';
import ProductCard from '../components/ProductCard';
import ProductCategoryCard from '../components/ProductCategoryCard';
import { useNavigate } from 'react-router-dom';
import { getSortedProductsByCategory } from '../controllers/ProductsConnectionLayer';
import { getAllCategories, getAllCategoryIds } from '../controllers/CategoryConnectionLayer';
import useViewport from '../hooks/useViewport';
import '../style/ProductCard.css'
import '../style/AppPages.css'
import Loading from '../components/Loading';
import { useTranslation } from 'react-i18next';

const ProductsPage = () => {
  const { is1000pxView, isTinyMobileView } = useViewport();
  const navigate = useNavigate(); 
  const { t } = useTranslation();

  const [categories, setCategories] = useState([]);
  const [productsByCategory, setProductsByCategory] = useState(new Map());
  const [loading, setLoading] = useState(true);

  const slugify = (text) =>
    text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')        // Replace spaces with -
      .replace(/[^\w\-]+/g, '')    // Remove all non-word chars
      .replace(/\-\-+/g, '-');     // Replace multiple - with single -

  const routeChange = (product) => {
    const slug = slugify(product.name);
    navigate(`/product/${slug}`);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const categoryIds = await getAllCategoryIds();
        const allCategories = await getAllCategories();
        const products = await getSortedProductsByCategory(categoryIds);  // Async

        setCategories(allCategories);
        setProductsByCategory(products);
      } catch (error) {
        console.error("Error fetching data: ", error);
      } finally {
        setLoading(false); // Once data is fetched, set loading to false
      }
    };

    fetchData();
  }, []); // Empty dependency array ensures this effect runs once on mount

  return (
    <>
    <Loading isVisible={loading} />
      {!loading && (
        <div className="page-padding-products products-page">
          {categories.map((category) => {

            const products = productsByCategory.get(category.id);

            if (!products || products.length === 0) return null;

            const productsToShow = isTinyMobileView ? 0 : is1000pxView ? 2 : 3;
            // const firstFewProducts = products.slice(0, productsToShow);
            // const remainingProducts = products.slice(productsToShow);

            return (
              <div
                className="toy-selection-card"
                key={"category-".concat(category.categoryLabel)}
                id={category.type}
              >
                <ProductCategoryCard
                  className="button-product-card"
                  categoryName={t('categories.' + category.type + 'Category')}
                  categoryDescription={t('categories.' + category.type + 'CategoryDescription')}
                />

                {/* <div className="products-line">
                  {firstFewProducts.map((product) => (
                    <button
                      className="button-product-card button-product-cards"
                      key={product.id}
                      onClick={() => routeChange(product.id)}
                    >
                      <ProductCard product={product} bigCard={true} />
                    </button>
                  ))}
                </div> */}

                <div className="other-products-line">
                  {products.map((product) => (
                    <button
                      className="other-button-product-card button-product-cards"
                      key={product.id}
                      onClick={() => routeChange(product)}
                    >
                      <ProductCard product={product} bigCard={false} />
                    </button>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default ProductsPage;
